module.exports = __webpack_public_path__ + "img/additional-header.91c39f25.png";